import React from "react";
import { useTranslation } from "react-i18next";

interface GenerationLoadingPanelProps {
  // i18n keys, one per phase row — e.g. risks.ai.loading.* for stage 1 or
  // risks.ai.detailLoading.* for the per-hazard stage-2 generation.
  phaseKeys: string[];
}

// Generic multi-phase loading checklist for the long synchronous AI calls.
// Visual clone of the AIStandardResearch loading panel (bordered cyan box,
// animate-pulse rows with an inline spinner) — deliberately NOT a refactor
// of that component (plan §5).
export const GenerationLoadingPanel = ({
  phaseKeys,
}: GenerationLoadingPanelProps) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border border-cyan-200 bg-cyan-50 p-4">
      <ul className="space-y-2">
        {phaseKeys.map((key) => (
          <li key={key} className="flex items-center gap-2 animate-pulse">
            <svg
              className="h-4 w-4 text-cyan-600 animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              />
            </svg>
            <span className="text-sm text-cyan-700">{t(key)}</span>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-cyan-700">
        {t("risks.ai.loading.keepOpen")}
      </p>
    </div>
  );
};
